import { IAutomationObject } from '../../types'

export interface IAcknowledge extends IAutomationObject {
    ack: boolean;
    isErr: boolean;
    isAck: boolean;
    errDelay: number;
    errSum: boolean;

    onValueChanged: any;

}

export const schema = 'AutomationApps.Devices.Commons.Acknowledge';